import { render, staticRenderFns } from "./SoSanhDienNuoc.vue?vue&type=template&id=5996ed52&scoped=true"
import script from "./SoSanhDienNuoc.vue?vue&type=script&lang=js"
export * from "./SoSanhDienNuoc.vue?vue&type=script&lang=js"
import style0 from "./SoSanhDienNuoc.vue?vue&type=style&index=0&id=5996ed52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996ed52",
  null
  
)

export default component.exports